"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DeleteButton;
var _react = _interopRequireDefault(require("react"));
var _button = _interopRequireDefault(require("./button"));
var _delete = _interopRequireDefault(require("../../icons/delete"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var _ref = /*#__PURE__*/_react.default.createElement(_delete.default, null);
function DeleteButton(props) {
  return /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_button.default, _extends({}, props, {
    type: "default",
    title: props.title || 'Delete'
  }), _ref));
}